import React, {useEffect, useMemo, useRef, useState} from 'react';
import {ScenarioActionProps} from '../../actionMenuTypes';
import SubModelActionMenu from '../../subModel/common/SubModelActionMenu/SubModelActionMenu';
import DefaultPage from '../../../layout/common/DefaultPage';
import ScenarioParameters, {
  ScenarioParametersRefType,
} from '../../../core/ModelInput/ScenarioParameters/ScenarioParameters';
import SideBar from '../../../layout/common/SideBar';
import {ScenarioParametersSubmitType} from '../editor/ScenarioParametersJSONEditor';
import SubModelSectionHeader from '../../subModel/common/SubModelSectionHeader/SubModelSectionHeader';
import {typeToSection} from '../../../../store/executionSetup';
import styles from './ScenarioParametersBuilder.module.scss';
import {useAuth} from '../../../../store/auth';
import {MRAppRoutes, useMatchedRoute} from '../../../router/routes';
import {useUserExpertise} from '../../../../store/userExpertise';
import ScenarioParametersExportToWordActionMenuButton from '../common/ScenarioParametersExportToWord/ScenarioParametersExportActionMenuButton';

const ScenarioParametersBuilder: React.FC<Omit<ScenarioActionProps, 'scenario'> & ScenarioParametersSubmitType> = ({
  model,
  subModel,
  input,
  scenario,
  submitting,
}) => {
  const inputListPortalRef = useRef<HTMLDivElement>(null);
  const section = typeToSection(subModel.type);

  const definitions = useMemo(() => {
    const parsed = input.value ? JSON.parse(input.value) : {};
    return parsed.definitions || [];
  }, [input]);

  const values = useMemo(() => {
    return JSON.parse(scenario.input.value || '{}');
  }, [scenario]);

  const scenarioParametersRef = useRef<ScenarioParametersRefType>();

  const {auth} = useAuth();
  const user = auth.loggedInUser;
  const userid = user ? user.id : '';
  const {modelUuid} = useMatchedRoute(MRAppRoutes.SCENARIO_PARAMETERS_VIEW);
  const [expertiseLevel, setExpertiseLevel] = useState<number>();

  const expertiseLevelObject = useUserExpertise(modelUuid, userid);

  useEffect(() => {
    setExpertiseLevel(Number(expertiseLevelObject?.expertiseTypeLevel?.split('-')[0]));
  }, [expertiseLevelObject]);

  return (
    <>
      <SideBar
        position="left"
        className="leftSelection"
        style={{boxShadow: '5px 0px 4px rgba(0,0,0,0.3)', position: 'relative', zIndex: 2}}
      >
        <h3 style={{paddingLeft: 15}}>Parameters</h3>
        <div ref={inputListPortalRef} />
      </SideBar>
      <DefaultPage style={{position: 'relative'}}>
        <div className={styles.container}>
          <SubModelSectionHeader
            model={model}
            section={section}
            subModel={subModel}
            scenario={scenario}
            title="Instance's parameters"
          />
          <div style={{display: 'flex', justifyContent: 'flex-end'}}>
            <ScenarioParametersExportToWordActionMenuButton model={model} subModel={subModel} scenario={scenario} />
          </div>
          <div className={styles.parametersWrapper}>
            <ScenarioParameters
              expertiseLevel={expertiseLevel ? expertiseLevel : 500}
              subModelType={subModel.type!}
              ref={scenarioParametersRef}
              key={input.value}
              definitions={definitions}
              values={values}
              renderStatic
              submitting={submitting}
              inputListPortalRef={inputListPortalRef}
              modelUuid={modelUuid}
              scenario={scenario}
            />
          </div>
        </div>
      </DefaultPage>
      <SubModelActionMenu model={model} section={section} subModel={subModel} scenario={scenario} />
    </>
  );
};

export default ScenarioParametersBuilder;
